import clone from "lodash.clonedeep";
import { ARCHIVE_STATUSES, RECORD_STATUSES, CUT_STATUSES, TYPE_OFFLINE } from "../constants/common";

export const getStreamRecordStatus = (stream) => {
    if (!stream) return null;

    let recordStatus = null;

    const filteredEpisodes = stream.episode.filter(({ delay }) => !delay);
    const isAllEpisodesNotOnline = filteredEpisodes.every(({ participationType }) => participationType !== TYPE_OFFLINE);
    const isSomeEpisodesHasCutStatus = filteredEpisodes.some(({ archiveStatus }) => CUT_STATUSES.includes(archiveStatus.toLowerCase()))

    if (!!filteredEpisodes?.length && isAllEpisodesNotOnline && isSomeEpisodesHasCutStatus) {
        recordStatus = RECORD_STATUSES.EPISODES_CUT
    } else if (stream.archiveStatus?.toLowerCase() === ARCHIVE_STATUSES.FILE) {
        recordStatus = RECORD_STATUSES.RECORD_CUT
    }  else if (stream.archiveStatus?.toLowerCase() === ARCHIVE_STATUSES.DONE) {
        recordStatus = RECORD_STATUSES.RECORD
    }

    return recordStatus;
}

export const getEpisodeRecordStatus = (episode) => {
    if (!episode) return null;

    const {delay, archiveStatus, participationType} = episode;

    if (!delay && CUT_STATUSES.includes(archiveStatus?.toLowerCase()) && participationType !== TYPE_OFFLINE) {
        return RECORD_STATUSES.EPISODES_CUT;
    } else if (archiveStatus?.toLowerCase() === ARCHIVE_STATUSES.FILE) {
        return RECORD_STATUSES.RECORD_CUT;
    }  else if (archiveStatus?.toLowerCase() === ARCHIVE_STATUSES.DONE) {
        return RECORD_STATUSES.RECORD;
    }

    return null;
}

export const getFilteredStreams = (streams, targetParticipationType, settings) => {
    if (!streams || !Array.isArray(streams)) return [];

    if (targetParticipationType) {
        streams = streams.filter(({participationType}) => !participationType || participationType === "hybrid" || participationType === targetParticipationType);
    }

    if (settings?.streamsIds?.length > 0) {
      streams = streams.filter(({id}) => settings.streamsIds.includes(String(id)));
    }

    return streams;
}

export const getEpisodeData = (episode) => {
    if (!episode) {
        return null;
    }

    const { id, key, externalId, name_ru, name_en, info_ru, info_en, timeStart, timeStop } = episode;

    return {
        id,
        key,
        externalId,
        timeStart,
        timeStop,
        nameRu: name_ru,
        nameEn: name_en,
        descriptionRu: info_ru,
        descriptionEn: info_en,
    };
};
